import { getComposeEvent } from 'owa-calendar-compose-store-manager';
import { orchestrator } from 'satcheljs';
import {
    onRoomRequestedChanged,
    updateLocations,
    setRoomBookingAssistantEnabled,
} from 'owa-calendar-compose-form-actions';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import {
    removeLocationsTitle,
    removeLocationsDescription,
} from './onRoomRequestedChanged.locstring.json';
import loc from 'owa-localize';

orchestrator(setRoomBookingAssistantEnabled, async actionMessage => {
    const { formId } = actionMessage;
    const event = getComposeEvent(formId);
    let isRoomBookingAssistantEnabled = actionMessage.isRoomBookingAssistantEnabled;

    // show confirmation dialog to remove existing locations if room bot is turned on
    if (isRoomBookingAssistantEnabled && event.Locations && event.Locations.length > 0) {
        if (
            (await confirm(loc(removeLocationsTitle), loc(removeLocationsDescription), false, {
                delayCallbackAfterAnimation: true,
            })) == DialogResponse.ok
        ) {
            updateLocations(null, formId);
        } else {
            isRoomBookingAssistantEnabled = false;
        }
    }

    onRoomRequestedChanged(isRoomBookingAssistantEnabled, formId);
});
